export const MELODIES = [
  { 
    id: 'CLASSIC', 
    name: 'Classic',
    audioFile: '/sounds/classic.mp3',
    frequency: 600,
    type: 'sine',
    description: '经典闹钟 - 传统闹钟声'
  },
  { 
    id: 'NATURE', 
    name: 'Nature',
    audioFile: '/sounds/nature.mp3',
    frequency: 550,
    type: 'triangle',
    description: '自然之声 - 鸟鸣声'
  },
  { 
    id: 'BIOHAZARD', 
    name: 'Biohazard',
    audioFile: '/sounds/biohazard.mp3',
    frequency: 700,
    type: 'square',
    description: '生化警告 - 警示音效'
  },
  { 
    id: '8BIT_MACHINE', 
    name: '8-bit Machine',
    audioFile: '/sounds/8-bit-machine.mp3',
    frequency: 900,
    type: 'square',
    description: '8位机音效 - 复古游戏风格'
  },
  { 
    id: 'CHURCH_BELL', 
    name: 'Church Bell',
    audioFile: '/sounds/church-bell.mp3',
    frequency: 600,
    type: 'sine',
    description: '教堂钟声 - 庄严的钟声'
  },
  { 
    id: 'POLICE_SIREN', 
    name: 'Police Siren',
    audioFile: '/sounds/police-siren.mp3',
    frequency: 800,
    type: 'square',
    description: '警笛声 - 紧急警报音效'
  },
  { 
    id: 'SOUNDPAD', 
    name: 'Soundpad',
    audioFile: '/sounds/soundpad.mp3',
    frequency: 600,
    type: 'sine',
    description: '音效板 - 多样音效集合'
  },
  { 
    id: 'CHARLIE_KIRK', 
    name: 'We Are Charlie Kirk',
    audioFile: '/sounds/we-are-charlie-kirk-song.mp3',
    frequency: 600,
    type: 'sine',
    description: 'Charlie Kirk 歌曲 - 音乐闹钟'
  }
];